<template>
  <transition name="fade">
    <div
      v-if="$store.state.imageModal"
      class="video__player"
      @click.stop="$store.dispatch('closeImageModal')"
    >
      <div class="video__player-content -image" @click.stop>
        <img :src="$store.state.imageModal" class="video__player-content-image" alt="" />
        <button class="button -corner-bottom-left" @click="$store.dispatch('closeImageModal')">
          Fermer
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ImageModal',
}
</script>
